export const CLASS_NAMES = {
  container: 'flex flex-1 flex-col item-start',
};
